/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Table as TableComponent } from 'ypf-pas-general-ui-components';
import { useParams } from 'react-router-dom';
import { FaRegFileAlt } from 'react-icons/fa';

import { assignmentTypeEnum } from '../../../../../../utils/dataStatus';
import { formatDate } from '../../../../../../utils/formatUtils';
import { FilesSdsPtContext } from '../../../../../../context/FilesSdsPtContext';
import tableTypes from '../../../../../../utils/filesTableTypes';
import { DetailRequest, DetailRequestMonthly } from '../../../../../../utils/globalPropTypes';

import ButtonHeader from './ButtonHeader/ButtonHeader';

const Table = (props) => {
  const {
    onlyButtonDeletedFiles,
    disabledButtonDownloadDelete,
    columnSds,
    sds,
    disableButtonSDSCancelled,
    type,
    details,
    permissions,
    downloadOptions
  } = props;

  const {
    dataFilesSDS,
    dataFilesPt,
    dataInactivesSDS,
    getDataFilesSDS,
    getDataFilesPt,
    setInfoCompleteSelect,
    setInfoCompleteSelectDelete,
    dataInactivesPt,

    dateFilterRange
  } = useContext(FilesSdsPtContext);
  const isMonthly = details?.tipoAsignacion.id === assignmentTypeEnum.Mensualizada;
  const [select, setSelect] = useState([]);
  const { id } = useParams();

  const filesPt = [dataFilesPt, dataInactivesPt];
  const filesSDS = [dataFilesSDS, dataInactivesSDS];
  const attachedFiles = [filesPt, filesSDS].flat(Infinity);

  const isSdsActivesFilesTable = type === tableTypes.sds;
  const isPtActivesFilesTable = type === tableTypes.pt;
  const isSdsInactivesFilesTable = type === tableTypes.inactiveSDS;
  const isPtInactivesFilesTable = type === tableTypes.inactivePT;

  const selectTableFiles = () => {
    if (isSdsActivesFilesTable) return dataFilesSDS;
    if (isPtActivesFilesTable) return dataFilesPt;
    if (isSdsInactivesFilesTable) return dataInactivesSDS;
    if (isPtInactivesFilesTable) return dataInactivesPt;

    return [];
  };

  const selectAll = () => {
    const tableFiles = selectTableFiles();

    if (select.length < tableFiles.length) {
      const ids = tableFiles.map((item) => item.id);

      setSelect(ids);
    } else {
      setSelect([]);
    }
  };

  const handleChangeSelect = (item) => {
    if (select.includes(item)) {
      const newSelect = select.filter((name) => name !== item);

      setSelect(newSelect);

      return;
    }
    setSelect([...select, item]);
  };

  const justify = {
    textAlign: 'center',
    padding: 20
  };

  const sizeFile = ({ value }) => {
    const valueMb = Math.round(value / 1024);

    return `${valueMb} kb`;
  };

  const columns = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === dataFilesSDS.length && dataFilesSDS.length}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de Archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyItems: 'center',
            verticalAlign: 'center'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2 mt-3">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    },
    {
      Header: 'Fecha de subida',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Usuario',
      accessor: 'usuarioSubida',
      hideSort: true,
      style: justify
    }
  ];

  const columnsPt = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === dataFilesPt.length && dataFilesPt.length}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de Archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2 mt-3">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    },
    {
      Header: 'Fecha de carga',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Usuario',
      accessor: 'usuario',
      hideSort: true,
      style: justify
    },
    {
      Header: 'Pos./Lin - Fecha',
      accessor: 'linea',
      hideSort: true,
      style: justify
    }
  ];

  const columnsPtMonthly = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === dataFilesPt.length && dataFilesPt.length}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de Archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2 mt-3">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    },
    {
      Header: 'Fecha de carga',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Usuario',
      accessor: 'usuario',
      hideSort: true,
      style: justify
    },
    {
      Header: 'Ubicación',
      accessor: 'ubicacion',
      style: justify
    },
    {
      Header: 'Pos./Lin - Fecha',
      accessor: 'linea',
      hideSort: true,
      style: justify
    }
  ];

  const columnInactiveSDS = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === dataInactivesSDS.length && dataInactivesSDS.length}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2 mt-3">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    },
    {
      Header: 'Carga',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Eliminación',
      accessor: 'fechaElimina',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Usuario',
      accessor: 'usuarioElimina',
      hideSort: true,
      style: justify
    }
  ];

  const columnInactivePT = [
    {
      Header: () => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.length === dataInactivesPt.length && dataInactivesPt.length}
            onChange={selectAll}
            type="checkbox"
            value={undefined}
          />
          <div
            style={{
              marginLeft: 10
            }}
          >
            Nombre de archivo
          </div>
        </div>
      ),
      hideSort: true,
      accessor: 'nombre',
      Cell: ({ row }) => (
        <div
          style={{
            textAlign: 'center',
            display: 'flex'
          }}
        >
          <input
            defaultChecked={select.includes(row.original.id)}
            onChange={() => handleChangeSelect(row.original.id)}
            type="checkbox"
            value={undefined}
          />
          <p className="ms-2 mt-3">{row.values.nombre}</p>
        </div>
      )
    },
    {
      Header: 'Tamaño',
      accessor: 'peso',
      hideSort: true,
      style: justify,
      Cell: sizeFile
    },
    {
      Header: 'Carga',
      accessor: 'fechaSubida',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Eliminación',
      accessor: 'fechaElimina',
      hideSort: true,
      style: justify,
      Cell: formatDate
    },
    {
      Header: 'Usuario',
      accessor: 'usuarioElimina',
      hideSort: true,
      style: justify
    }
    // { La Propiedad no existe en la repuesta del back, consultar
    //   Header:'Pos./Lin - Fecha',
    //   accessor: 'linea',
    //   hideSort: true,
    //   style: justify
    // }
  ];

  const getColumnsCustom = () => {
    let columnsPrimary = [];

    if (columnSds) {
      columnsPrimary = columns;
    } else if (isMonthly) {
      columnsPrimary = columnsPtMonthly;
    } else {
      columnsPrimary = columnsPt;
    }

    return columnsPrimary;
  };

  useEffect(() => {
    let dataFiles = [];

    if (isSdsActivesFilesTable) dataFiles = dataFilesSDS;
    if (isPtActivesFilesTable) dataFiles = dataFilesPt;
    if (dataFiles?.length) {
      const completeInfo = dataFiles?.filter((item) => select.includes(item.id));

      setInfoCompleteSelect(completeInfo);
    }
  }, [select]);

  useEffect(() => {
    let dataInactives = [];

    if (isSdsInactivesFilesTable) dataInactives = dataInactivesSDS;
    if (isPtInactivesFilesTable) dataInactives = dataInactivesPt;
    if (dataInactives?.length) {
      const completeInfo = dataInactives?.filter((item) => select.includes(item.id));

      setInfoCompleteSelectDelete(completeInfo);
    }
  }, [select]);
  const fetchData = (value) => getDataFilesPt(details?.id, details, value?.sortBy);

  useEffect(() => {
    getDataFilesSDS(id);
    getDataFilesPt(id, details);
  }, []);

  const tableFetchProp = {
    ...(sds ? {} : { fetchData })
  };

  return (
    <>
      <div>
        <ButtonHeader
          attachedFiles={attachedFiles}
          details={details}
          disableButtonSDSCancelled={disableButtonSDSCancelled}
          disabledButtonDownloadDelete={disabledButtonDownloadDelete}
          downloadOptions={downloadOptions}
          onlyButtonDeletedFiles={onlyButtonDeletedFiles}
          permissions={permissions}
          sds={sds}
          select={select}
          setSelect={setSelect}
          showFilters={isPtActivesFilesTable}
          type={type}
        />
        {!onlyButtonDeletedFiles && (
          <div>
            <TableComponent
              borderless
              columns={getColumnsCustom()}
              data={sds ? dataFilesSDS : dataFilesPt}
              sortOrder
              type="light"
              {...tableFetchProp}
            />
            {!dataFilesPt.length && !sds && dateFilterRange?.startDateLimit?.length ? (
              <div className="d-flex flex-column justify-content-center text-center">
                <span className="m-10 fs-5">No se encontró ninguna coincidencia</span>
                <div className="text-center m-2">
                  <FaRegFileAlt size={30} />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        )}
        {onlyButtonDeletedFiles && isSdsInactivesFilesTable && (
          <TableComponent
            borderless
            columns={columnInactiveSDS}
            data={dataInactivesSDS}
            type="light"
          />
        )}
        {onlyButtonDeletedFiles && isPtInactivesFilesTable && (
          <TableComponent
            borderless
            columns={columnInactivePT}
            data={dataInactivesPt}
            type="light"
          />
        )}
      </div>
    </>
  );
};

export default Table;

Table.propTypes = {
  type: PropTypes.oneOf([
    tableTypes.pt,
    tableTypes.sds,
    tableTypes.inactivePT,
    tableTypes.inactiveSDS
  ]).isRequired,
  permissions: PropTypes.shape({
    delete: PropTypes.bool,
    download: PropTypes.bool,
    upload: PropTypes.bool
  }),
  onlyButtonDeletedFiles: PropTypes.bool.isRequired,
  disabledButtonDownloadDelete: PropTypes.bool.isRequired,
  columnSds: PropTypes.bool.isRequired,
  sds: PropTypes.bool.isRequired,
  disableButtonSDSCancelled: PropTypes.bool.isRequired,
  details: PropTypes.oneOfType([DetailRequest, DetailRequestMonthly]).isRequired
};

Table.defaultProps = {
  permissions: {
    delete: false,
    download: true,
    upload: false
  }
};
